import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GithubTokenService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/v1/users/me/github-token`;

  save(apiToken: string): Observable<void> {
    return this.http.put<void>(this.baseUrl, { apiToken });
  }

  delete(): Observable<void> {
    return this.http.delete<void>(this.baseUrl);
  }
}
